import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Config from '../../libraries/ReactNativeConfig';
import AppConfig from '../../config/AppConfig';
import colors from '../../theme/Colors';

const VariantCount = (props) => {
  const { variantsCount } = props;
  const sizeText = variantsCount <= 1 ? 'Size' : 'Sizes';
  return (
    <View style={styles.variantSizeTextContainer}>
      <Text style={styles.variantCount}>{variantsCount}</Text>
      <Text
        style={styles.variantCountText}
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {sizeText}
      </Text>
    </View>
  );
};
export default function ProductSizeVariants(props) {
  const { variantsCount, containerStyle, showVariantSizeCount = true } = props;
  if (
    variantsCount <= 0 ||
    !showVariantSizeCount ||
    AppConfig.getBooleanValue(Config.SHOW_ONLY_COLOR_VARIANTS_ON_PRODUCT_CARDS)
  ) {
    return null;
  }
  return (
    <View style={[styles.variantSizesContainer, containerStyle]}>
      <VariantCount variantsCount={variantsCount} />
    </View>
  );
}

const styles = StyleSheet.create({
  variantCountText: {
    fontSize: 10,
    marginLeft: 2,
    fontFamily: 'Roboto-Regular',
    color: colors.foxyBlack,
  },
  variantCount: {
    fontSize: 10,
    marginLeft: 0,
    fontFamily: 'Roboto-Regular',
    color: colors.foxyBlack,
  },
  variantSizesContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 2,
    paddingVertical: 0,
  },
  variantSizeTextContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 2,
    paddingVertical: 0,
  },
});
